import { motion } from 'motion/react';
import { Card } from './ui/card';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface TemperatureChartProps {
  data: Array<{
    time: string;
    aht_temp: number;
    bmp_temp: number;
    ds18_temp: number;
  }>;
}

const fmtTime = (v: string) =>
  new Date(v).toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' });

export function TemperatureChart({ data }: TemperatureChartProps) {
  const formatted = data.map(d => ({
    time: d.time,
    AHT:  Number(d.aht_temp?.toFixed?.(2) ?? d.aht_temp),
    BMP:  Number(d.bmp_temp?.toFixed?.(2) ?? d.bmp_temp),
    DS18: Number(d.ds18_temp?.toFixed?.(2) ?? d.ds18_temp),
  }));

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
      <Card className="p-6">
        <h3 className="mb-4">Temperatura – ostatnie 24h</h3>
        <ResponsiveContainer width="100%" height={300}>
          <AreaChart data={formatted}>
            <defs>
              <linearGradient id="tAHT" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%"  stopColor="#ef4444" stopOpacity={0.35}/>
                <stop offset="100%" stopColor="#ef4444" stopOpacity={0.05}/>
              </linearGradient>
              <linearGradient id="tBMP" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%"  stopColor="#3b82f6" stopOpacity={0.35}/>
                <stop offset="100%" stopColor="#3b82f6" stopOpacity={0.05}/>
              </linearGradient>
              <linearGradient id="tDS" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%"  stopColor="#10b981" stopOpacity={0.35}/>
                <stop offset="100%" stopColor="#10b981" stopOpacity={0.05}/>
              </linearGradient>
            </defs>

            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="time" tickFormatter={fmtTime} stroke="#6b7280" style={{ fontSize: 12 }} />
            <YAxis stroke="#6b7280" style={{ fontSize: 12 }} label={{ value: '°C', angle: -90, position: 'insideLeft' }} />
            <Tooltip
              labelFormatter={(t) => fmtTime(String(t))}
              formatter={(val: number) => [`${val.toFixed(2)}°C`, '']}
              contentStyle={{ backgroundColor: 'rgba(255,255,255,0.95)', border: '1px solid #e5e7eb', borderRadius: 8 }}
            />
            <Legend />

            <Area type="monotone" dataKey="AHT" stroke="#ef4444" strokeWidth={2} fill="url(#tAHT)" dot={false} animationDuration={400}/>
            <Area type="monotone" dataKey="BMP" stroke="#3b82f6" strokeWidth={2} fill="url(#tBMP)" dot={false} animationDuration={400}/>
            <Area type="monotone" dataKey="DS18" stroke="#10b981" strokeWidth={2} fill="url(#tDS)" dot={false} animationDuration={400}/>
          </AreaChart>
        </ResponsiveContainer>
      </Card>
    </motion.div>
  );
}
